import React, { useEffect, useRef, useState } from "react";

/**
 * ModalOptionsWithSub
 * Igual que ModalOptions pero soporta opciones con submenú al costado.
 *
 * Props:
 *   options  — [{ label, onClick, subOptions?: [{ label, onClick }] }]
 *   onClose  — fn()
 */
export const ModalOptionsWithSub = ({ options = [], onClose }) => {
    const ref = useRef(null);
    const [openSub, setOpenSub] = useState(null); // índice de la opción con submenú abierto

    // Cerrar al click fuera
    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                onClose?.();
            }
        };
        const timer = setTimeout(() => {
            document.addEventListener("click", handler);
        }, 0);
        return () => {
            clearTimeout(timer);
            document.removeEventListener("click", handler);
        };
    }, [onClose]);

    // Cerrar con Escape
    useEffect(() => {
        const handler = (e) => { if (e.key === "Escape") onClose?.(); };
        document.addEventListener("keydown", handler);
        return () => document.removeEventListener("keydown", handler);
    }, [onClose]);

    return (
        <div ref={ref} className="pa-list-popover">
            {options.map((opt, i) => (
                <div
                    key={i}
                    className={`pa-list-popover__option pa-list-popover__option--sub-wrap ${openSub === i ? "pa-list-popover__option--active" : ""}`}
                    onClick={() => {
                        if (opt.subOptions?.length) {
                            // tiene submenú → toggle, no ejecutar onClick
                            setOpenSub(prev => prev === i ? null : i);
                        } else {
                            opt.onClick?.();
                            onClose?.();
                        }
                    }}
                >
                    {/* Flecha indicadora de submenú */}
                    {opt.subOptions?.length > 0 && (
                        <span className="pa-list-popover__arrow">◀</span>
                    )}

                    <span>{opt.label}</span>

                    {/* Submenú al costado derecho */}
                    {opt.subOptions?.length > 0 && openSub === i && (
                        <div
                            className="pa-list-popover pa-list-popover--sub"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {opt.subOptions.map((sub, si) => (
                                <div
                                    key={si}
                                    className="pa-list-popover__option"
                                    onClick={() => {
                                        sub.onClick?.();
                                        onClose?.();
                                    }}
                                >
                                    {sub.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default ModalOptionsWithSub;